export const cacheKeys = {
  getUser: 'getUser',
  getUsers: 'getUsers',
  getInvite: 'getInvite',
  createUser: 'createUser',
  editUser: 'editUser',
  patchUser: 'patchUser',
  deleteUser: 'deleteUser',
  inviteUser: 'inviteUser',
  getPreferenceHistory: 'getPreferenceHistory',
};
